import { render, staticRenderFns } from "./MGBenefitCalculator.vue?vue&type=template&id=5bb76889"
import script from "./MGBenefitCalculator.vue?vue&type=script&lang=js"
export * from "./MGBenefitCalculator.vue?vue&type=script&lang=js"
import style0 from "./MGBenefitCalculator.vue?vue&type=style&index=0&id=5bb76889&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports